import {Component, DoCheck, Inject, OnInit} from '@angular/core';
import {CompetitorSimple} from '../../../../types/competitor';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EditCrewCardInfo} from '../../../../types/editCrewCardInfo';
import {EditCrewCardService} from './service/edit-crew-card.service';

@Component({
  selector: 'app-edit-crew-card',
  templateUrl: './edit-crew-card.component.html',
  styleUrls: ['./edit-crew-card.component.css']
})
export class EditCrewCardComponent implements OnInit, DoCheck {

  crewCardForm: UntypedFormGroup;

  drivers: CompetitorSimple[];
  navigators: CompetitorSimple[];
  additionalCompetitors: CompetitorSimple[];
  availableCompetitors: CompetitorSimple[];
  numbers: number[];

  serverIsDown = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: EditCrewCardInfo, private dialogRef: MatDialogRef<EditCrewCardComponent>,
              private editCrewCardService: EditCrewCardService) {}

  ngOnInit(): void {
    this.editCrewCardService.initializeComponentData(this.data, this.dialogRef);
    this.crewCardForm = this.editCrewCardService.crewCardForm;
    this.numbers = this.editCrewCardService.numbers;
    this.drivers = this.editCrewCardService.drivers;
    this.navigators = this.editCrewCardService.navigators;
    this.additionalCompetitors = this.editCrewCardService.additionalCompetitors;
    this.availableCompetitors = this.editCrewCardService.availableCompetitors;
    this.serverIsDown = this.editCrewCardService.serverIsDown;
  }

  ngDoCheck(): void {
    this.editCrewCardService.refilterDropdowns(this.data);
    this.drivers = this.editCrewCardService.drivers;
    this.navigators = this.editCrewCardService.navigators;
    this.additionalCompetitors = this.editCrewCardService.additionalCompetitors;
    this.availableCompetitors = this.editCrewCardService.availableCompetitors;
    this.serverIsDown = this.editCrewCardService.serverIsDown;
  }

  /**
   * function for setting default value for dropdown based on comparing ids of competitors
   * @param formControlName for formControlName parameter
   * @param selectedOption for dropdown option values
   */
  compareCompetitors(formControlName: CompetitorSimple, selectedOption: CompetitorSimple): boolean {
    return formControlName && selectedOption && formControlName.id === selectedOption.id;
  }

  /**
   * function which provides error messages in the process of updating crew card
   * @param fieldControl with information about desired field (driver, navigator, ...)
   */
  getErrorMessage(fieldControl: AbstractControl): string {
    return this.editCrewCardService.getErrorMessage(fieldControl);
  }

  /**
   * function for creating the crew with provided data
   */
  onSaveCrew(): void {
    this.editCrewCardService.onSaveCrew();
  }

  /**
   * function for evaluation of available competitors based on additional competitors
   */
  processAvailableCompetitors(): void {
    this.editCrewCardService.processAvailableCompetitors();
  }

  /**
   * function for disabling add additional competitor, if additional competitor
   * dropdown is empty
   */
  additionalCompetitorFieldIsEmpty(): boolean {
    return this.editCrewCardService.additionalCompetitorFieldIsEmpty();
  }

  /**
   * function for removing desired competitor from additional competitors list
   * @param competitor for evaluation of competitor to delete
   */
  deleteAdditionalCompetitor(competitor: CompetitorSimple): void {
    this.editCrewCardService.deleteAdditionalCompetitor(competitor);
  }
}
